<template>
  <div class="container my-5">
    <div class="card shadow-sm">
      <div class="card-body">
        
        <h2 class="mb-4 text-center">📊 Histórico de Atendimentos</h2>
        <div class="row">
          <!-- Linha 1: Datas -->
          <div class="col-md-4">
            <label for="dataInicial">Data Inicial</label>
            <input type="date" class="form-control" v-model="filtro.dataInicial" />
          </div>
          <div class="col-md-4">
            <label for="dataFinal">Data Final</label>
            <input type="date" class="form-control" v-model="filtro.dataFinal" />
          </div>
          <div class="col-md-4">
            <label for="diaSemana">Dia da Semana</label>
            <select class="form-control" v-model="filtro.diaSemana">
              <option value="">Todos</option>
              <option value="domingo">Domingo</option>
              <option value="segunda-feira">Segunda-feira</option>
              <option value="terça-feira">Terça-feira</option>
              <option value="quarta-feira">Quarta-feira</option>
              <option value="quinta-feira">Quinta-feira</option>
              <option value="sexta-feira">Sexta-feira</option>
              <option value="sábado">Sábado</option>
            </select>
          </div>

          <!-- Linha 2: Campanha, Telefone, Nome -->
          <div class="col-md-4 mt-3">
            <label for="campanha">Campanha</label>
            <input type="text" class="form-control" v-model="filtro.campanha" />
          </div>
          <div class="col-md-4 mt-3">
            <label for="telefoneCliente">Telefone Cliente</label>
            <input type="text" class="form-control" v-model="filtro.telefoneCliente" />
          </div>
          <div class="col-md-4 mt-3">
            <label for="nomeCliente">Nome Cliente</label>
            <input type="text" class="form-control" v-model="filtro.nomeCliente" />
          </div>

          <!-- Linha 3: Botão -->
          <div class="col-md-12 mt-4 d-flex justify-content-end">
            <button class="btn btn-primary" @click="fetchAtendimentos">
              Buscar
            </button>
          </div>
        </div>
        <br>
        <!-- Métricas -->
        <!--
        <div class="row text-center mb-4">
          <div class="col-md-3 mb-2">
            <div class="card text-white bg-danger h-100">
              <div class="card-body">
                <h5 class="card-title">Recebidos</h5>
                <p class="card-text fs-4">{{ metricas.recebidos }}</p>
              </div>
            </div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="card text-white bg-primary h-100">
              <div class="card-body">
                <h5 class="card-title">Finalizados/Bot</h5>
                <p class="card-text fs-4">{{ metricas.finalizadosBot }}</p>
              </div>
            </div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="card text-dark bg-warning h-100">
              <div class="card-body">
                <h5 class="card-title">Atendimentos/Agentes</h5>
                <p class="card-text fs-4">{{ metricas.atendimentosAgente }}</p>
              </div>
            </div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="card text-dark bg-light h-100">
              <div class="card-body">
                <h5 class="card-title">Goal</h5>
                <p class="card-text fs-4">{{ metricas.goal }}</p>
              </div>
            </div>
          </div>
        </div>
-->
        <!-- Tabela de histórico -->
        <div class="card border-0">
          <div class="card-body p-0">
            <DataTable
                :data="atendimentos"
                :columns="columns"
                @linhaSelecionada="abrirModal"
            />
          </div>
        </div>
        <!-- Modal de histórico -->
        <div v-if="modalAberto" class="modal-backdrop-custom">
            <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content shadow">
                <div class="modal-header">
                <h5 class="modal-title">Histórico de Mensagens</h5>
                <button type="button" class="btn-close" @click="fecharModal"></button>
                </div>
                <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
                <div class="message-day" ref="container">
                    <div
                    v-for="message in mensagens"
                    :key="message.internalId"
                    :class="message.incoming ? 'chm message' : 'chm message self'"
                    :id="message.internalId"
                    >
                    <div class="message-wrapper">
                    <!-- Texto -->
                    <div v-if="Validar.isText(message.message)" class="message-content">
                    <span v-html="message.message" style="overflow-wrap: break-word;"></span>
                    </div>

                    <!-- Imagem -->
                    <div v-if="Validar.isImage(message.message)" class="message-content">
                    <a :href="Validar.returnImageURL(message.message)" target="_blank">
                        <img
                        :src="Validar.returnImageURL(message.message)"
                        alt=""
                        style="height: 50px; width: 50px; max-height: 50px; max-width: 50px;"
                        />
                    </a>
                    <br />
                    <span v-html="Validar.returnImageText(message.message)"></span>
                    </div>

                    <!-- Documento -->
                    <div v-if="Validar.isDocument(message.message)" class="message-content">
                    <a :href="Validar.returnURL(message.message)" target="_blank">
                        <img :src="require('@/assets/images/file.png')" alt="" />
                    </a>
                    <br />
                    <span v-html="Validar.returnImageText(message.message)"></span>
                    </div>

                    <!-- Áudio -->
                    <div
                    v-if="Validar.isAudio(message.message) || Validar.isVoice(message.message)"
                    class="message-content"
                    >
                    <audio controls :src="Validar.returnURL(message.message)" style="max-width: 90%;">
                        Seu navegador não suporta áudio.
                    </audio>
                    </div>

                    <!-- Vídeo -->
                    <div v-if="Validar.isVideo(message.message)" class="message-content">
                    <video controls :src="Validar.returnURL(message.message)" style="max-width: 90%;">
                        Seu navegador não suporta vídeo.
                    </video>
                    </div>
                </div>
                    <div v-if="!Validar.isSystem(message.message)" class="message-options">
                        <div class="avatar avatar-sm">
                        <img
                            v-if="message.incoming"
                            :src="require(`@/assets/images/${message.channel}.png`)"
                            alt=""
                        />
                        <img
                            v-else
                            :src="require('@/assets/images/icon-user.png')"
                            alt=""
                        />
                        </div>
                        <span class="message-date">{{ formatarData(message.timestamp) }}</span>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
       
      </div>
    </div>
  </div>
</template>
<script>
import DataTable from './DataTable.vue';
import moment from "moment";

import { useStore } from 'vuex';
import { computed } from 'vue';
import ChatService from '../services/ChatService';
import constants from '../util/constants';
import Validar from "../util/Validadores";
import {
    useToast
} from "vue-toastification";
const toast = useToast();

export default {
  
  name: 'HistoricoAgente',
  components: { DataTable },
  data() {
    return {
      filtro: {
        dataInicial: this.formatarData(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)), // 7 dias atrás
        dataFinal: this.formatarData(new Date()),
        diaSemana: '',
        campanha: '',
        telefoneCliente: '',
        nomeCliente: ''
      },


        atendimentos: [],
        mensagens: [],
        modalAberto: false,
        atendimentoSelecionado: null,
        columns: [
          { label: 'Protocolo', field: 'protocolo' },
          { label: 'Chat UUID', field: 'chatUUID' },
          { label: 'Telefone Cliente', field: 'telefone' },
          { label: 'Nome Cliente', field: 'cliente' },
          { label: 'Motivo Finalização', field: 'motivoFinalizacao' },
          { label: 'Data Início', field: 'dataInicio' },
          { label: 'Data Fim', field: 'dataFim' },
          { label: 'Status', field: 'status' }
        ],
        metricas: {
            recebidos: 0,
            finalizadosBot: 0,
            atendimentosAgente: 0,
            goal: 0,
        },
        Validar,
    };
  },
  mounted() {
    //this.fetchAtendimentos();
  },
  setup() {
    const store = useStore();
    store.commit('setUsuario', JSON.parse(localStorage.getItem('usuario')));

    const nomeUsuario = computed(() => {
  return store.state.usuario && store.state.usuario.nome
    ? store.state.usuario.nome
    : '';
});
const toast = useToast();

const emailUsuario = computed(() => {
  return store.state.usuario && store.state.usuario.email
    ? store.state.usuario.email
    : '';
});

const empresaUsuario = computed(() => {
  return store.state.usuario &&
    store.state.usuario.empresa &&
    store.state.usuario.empresa.nomeFantasia
    ? store.state.usuario.empresa.nomeFantasia
    : '';
});

    return {
      nomeUsuario,
      emailUsuario,
      empresaUsuario,
    };
  },
  methods: {
    formatarData(timestamp) {
        const timezoneDefault = 'America/Sao_Paulo';
        return moment(timestamp).tz(timezoneDefault).format('DD/MM/YYYY HH:mm');
    },
    abrirModal(item) {
        this.atendimentoSelecionado = item;
        this.modalAberto = true;
        console.log("item.chatUUID: ", item.chatUUID)
        this.buscarHistorico(item.chatUUID, item.chatId);
    },
    fecharModal() {
        this.modalAberto = false;
        this.mensagens = [];
    },
    buscarHistorico(chatUUID, chatId) {
        const empresaId = JSON.parse(localStorage.getItem('usuario')).empresaId;

        ChatService.getHistoryByChatUUI(chatUUID, chatId, empresaId)
        .then((res) => {
            console.log("mensagens: ", res.data)
            this.mensagens = res.data;
        })
        .catch((err) => {
            console.error('Erro ao buscar histórico:', err);
            this.mensagens = [];
        });
    },



    fetchAtendimentos() {
      if (!this.filtro.dataInicial || !this.filtro.dataFinal) {
        toast.warning('Por favor, preencha as datas inicial e final.')
        return;
      }


      const usuario = JSON.parse(localStorage.getItem('usuario'));
      //const agentId = usuario.id;
      //const empresaId = usuario.empresaId;

      const payload = {
        dataInicial: this.filtro.dataInicial + 'T00:00:00',
        dataFinal: this.filtro.dataFinal + 'T23:59:59',
        agentId: usuario.id,
        empresaId: usuario.empresaId,
        diaSemana: this.filtro.diaSemana,
        campanha: this.filtro.campanha,
        telefoneCliente: this.filtro.telefoneCliente,
        nomeCliente: this.filtro.nomeCliente
      };
      this.atendimentos = []; // limpa antes de buscar
      ChatService.GetAllItemsByDatesCompanyAgent(payload)
        .then((res) => {
          this.atendimentos = res.data.map(item => ({
            dataInicio: new Date(item.dateAdded).toLocaleString('pt-BR'),
            dataFim: item.dateFinished ? new Date(item.dateFinished).toLocaleString('pt-BR') : '',
            chatUUID: item.chatUUID,
            telefone: item.chatId,
            cliente: item.displayName || 'Não Informado',
            motivoFinalizacao: item.tab && item.tab.nome ? item.tab.nome : 'Não informado',
            status: item.finished ? 'Finalizado' : item.flowName || 'Em andamento',
            protocolo: item.protocol,
          }));

          this.calcularMetricas();
        })
        .catch((err) => {
          toast.warning('Não foi possível realizar a consulta, verifique as informações novamente.')
          console.error('Erro ao buscar atendimentos:', err);
      });


    },
    calcularMetricas() {
        const recebidos = this.atendimentos.length;
        let finalizados = 0;
        let atendimentos = 0;
        let goalPoints = 0;

        this.atendimentos.forEach(c => {
            if (c.status == 'Finalizado') {
                
                finalizados++;
            }

            atendimentos = recebidos;

            if (c.goalPoint === true) {
                goalPoints++;
            }
        });

    this.metricas = {
        recebidos,
        finalizadosBot: finalizados,
        atendimentosAgente: atendimentos,
        goal: `${goalPoints}`,
    };
    }
  },
};
</script>
<style scoped>
.modal-backdrop-custom {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>